// Judge.me Reviews 
(function() {
  'use strict';
  
  const cyrillicToLatin = {
      'А': 'A', 'а': 'a', 'Б': 'B', 'б': 'b', 'В': 'V', 'в': 'v',
      'Г': 'G', 'г': 'g', 'Д': 'D', 'д': 'd', 'Ђ': 'Đ', 'ђ': 'đ',
      'Е': 'E', 'е': 'e', 'Ж': 'Ž', 'ж': 'ž', 'З': 'Z', 'з': 'z',
      'И': 'I', 'и': 'i', 'Ј': 'J', 'ј': 'j', 'К': 'K', 'к': 'k',
      'Л': 'L', 'л': 'l', 'Љ': 'Lj', 'љ': 'lj', 'М': 'M', 'м': 'm',
      'Н': 'N', 'н': 'n', 'Њ': 'Nj', 'њ': 'nj', 'О': 'O', 'о': 'o',
      'П': 'P', 'п': 'p', 'Р': 'R', 'р': 'r', 'С': 'S', 'с': 's',
      'Т': 'T', 'т': 't', 'Ћ': 'Ć', 'ћ': 'ć', 'У': 'U', 'у': 'u',
      'Ф': 'F', 'ф': 'f', 'Х': 'H', 'х': 'h', 'Ц': 'C', 'ц': 'c',
      'Ч': 'Č', 'ч': 'č', 'Џ': 'Dž', 'џ': 'dž', 'Ш': 'Š', 'ш': 'š'
  };

  function convertCyrillicToLatin(text) {
      if (!text || typeof text !== 'string') return text;
      
      let result = text
          .replace(/ћ/g, 'ć')
          .replace(/ј/g, 'j') 
          .replace(/њ/g, 'nj')
          .replace(/љ/g, 'lj')
          .replace(/џ/g, 'dž')
          .replace(/ђ/g, 'đ');
      
      result = result.replace(/[А-Яа-яЁё]/g, char => cyrillicToLatin[char] || char);
      
      return result;
  }

  function convertTextNodes(element) {
      if (!element) return;
      
      if (element.nodeType === Node.TEXT_NODE) {
          const originalText = element.textContent;
          const convertedText = convertCyrillicToLatin(originalText);
          if (originalText !== convertedText) {
              element.textContent = convertedText;
          }
          return;
      }
      
      if (element.nodeType === Node.ELEMENT_NODE) {
          ['placeholder', 'title', 'value'].forEach(attr => {
              if (element[attr] && typeof element[attr] === 'string') {
                  const originalValue = element[attr];
                  const convertedValue = convertCyrillicToLatin(originalValue);
                  if (originalValue !== convertedValue) {
                      element[attr] = convertedValue;
                  }
              }
          });
      }
      
      const children = Array.from(element.childNodes);
      children.forEach(child => convertTextNodes(child));
  }

  function convertJudgemeContent() {
      try {
          const selectors = [
              '#judgeme_product_reviews',
              '.jdgm-widget',
              '.jdgm-review-widget',
              '[class*="jdgm"]'
          ];
          
          let converted = false;
          
          selectors.forEach(selector => {
              const elements = document.querySelectorAll(selector);
              elements.forEach(element => {
                  convertTextNodes(element);
                  converted = true;
              });
          });
          
          if (!converted) {
              const walker = document.createTreeWalker(
                  document.body,
                  NodeFilter.SHOW_TEXT,
                  {
                      acceptNode: function(node) {
                          return node.textContent.match(/[А-Яа-яЁёћјњљџђ]/) ? 
                              NodeFilter.FILTER_ACCEPT : 
                              NodeFilter.FILTER_REJECT;
                      }
                  }
              );
              
              const textNodes = [];
              let node;
              while (node = walker.nextNode()) {
                  textNodes.push(node);
              }
              
              textNodes.forEach(textNode => {
                  textNode.textContent = convertCyrillicToLatin(textNode.textContent);
              });
          }
      } catch (error) {
          console.warn('Judge.me konverter greška:', error);
      }
  }

  function setupObserver() {
      try {
          const observer = new MutationObserver(function(mutations) {
              let shouldConvert = false;
              
              mutations.forEach(function(mutation) {
                  mutation.addedNodes.forEach(function(node) {
                      if (node.nodeType === Node.ELEMENT_NODE) {
                          if (node.matches && node.matches('[class*="jdgm"]') ||
                              node.querySelector && node.querySelector('[class*="jdgm"]') ||
                              node.textContent && node.textContent.match(/[А-Яа-яЁёћјњљџђ]/)) {
                              shouldConvert = true;
                          }
                      } else if (node.nodeType === Node.TEXT_NODE) {
                          if (node.textContent && node.textContent.match(/[А-Яа-яЁёћјњљџђ]/)) {
                              shouldConvert = true;
                          }
                      }
                  });
                  
                  if (mutation.type === 'characterData') {
                      if (mutation.target.textContent && mutation.target.textContent.match(/[А-Яа-яЁёћјњљџђ]/)) {
                          shouldConvert = true;
                      }
                  }
              });
              
              if (shouldConvert) {
                  setTimeout(convertJudgemeContent, 100);
              }
          });
          
          if (document.body) {
              observer.observe(document.body, { 
                  childList: true, 
                  subtree: true,
                  characterData: true
              });
          }
      } catch (error) {
          console.warn('Observer setup greška:', error);
      }
  }

  function init() {
      convertJudgemeContent();
      setupObserver();
  }

  if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
  } else {
      init();
  }

  setTimeout(convertJudgemeContent, 1000);
  setTimeout(convertJudgemeContent, 3000);
  setTimeout(convertJudgemeContent, 5000);

  window.addEventListener('load', function() {
      setTimeout(convertJudgemeContent, 500);
  });

})();